import { ObservableFromFetch } from "../ObservableFromFetch"

export default function GovPoolSelectionUpdate(DateSelected: string, DaysSelectedID: number) {
  const params = JSON.stringify({
    DateSelected: DateSelected,
    DaysSelectedID: DaysSelectedID
  })

  return ObservableFromFetch<string>("GovPool/UpdateGovDaysSelected", params, "post")
}
